module.exports = __webpack_public_path__ + "static/img/yellow_btn.40d2320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/yellow_btn.png
// module id = 6HIu
// module chunks = 1